import axios from "axios";
import React, { useState } from "react";
import { ClipLoader } from "react-spinners";
import { toast } from "react-toastify";
// https://support-url-webapp-hit.netlify.app
const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const sendMail = async (e) => {
    e.preventDefault();
    setLoading(true);

    await axios.post('https://support-url-tmt.onrender.com/send/mail', { name, email, message, phone }).then(function (response) {
      setName("");
      setEmail("");
      setPhone("");
      setMessage("");
      toast.success(response.data.message);
      setLoading(false);
    })
      .catch(function (error) {
        setLoading(false)
        toast.error(error.response.data.message);
      })

  };

  return (
    <section className="contact">
      <form onSubmit={sendMail}>
        <h1>CONTACT US</h1>
        <div>
          <label>Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div>
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div>
          <label>Phone</label>
          <input
            type="number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          {
            phone && phone.length > 10 ? (<p style={{ color: "red" }}>Invalid Phone *</p>) : (<></>)
          }
        </div>

        <div>
          <label>Message</label>
          <input
            type="text"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>
        <button
          type="submit"
          disabled={loading}
        >
          {loading && <ClipLoader size={20} color="white" />}
          Send Message
        </button>
      </form>
    </section>
  );
};

export default Contact;




// import axios from 'axios';
// import React, { useRef, useState } from 'react'
// import { ClipLoader } from 'react-spinners';
// import { toast } from 'react-toastify';

// const Contact = () => {

//   const [loading, setLoading] = useState(false);

//   const handleName = useRef();
//   const handleEmail = useRef();
//   const handlemessage = useRef();

//   const sendMail = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     let obj = {
//       "name": handleName.current.value,
//       "email": handleEmail.current.value,
//       "message": handlemessage.current.value,
//     }

//     await axios.post('http://localhost:4000/send/mail', obj).then(function (response) {
//       toast.success(response.data.message);
//       setLoading(false);
//     })
//       .catch(function (error) {
//         setLoading(false)
//         toast.error(error.response.data.message);
//       })
//   }


//   return (
//     <section className='contact'>
//       <form onSubmit={sendMail}>
//         <h1>CONTACT US</h1>
//         <div>
//           <label>Name:</label>
//           <input type="text" ref={handleName} />
//         </div>
//         <div>
//           <label>Email:</label>
//           <input type="email" ref={handleEmail} />
//         </div>
//         <div>
//           <label>Message:</label>
//           <input type="text" ref={handlemessage} />
//         </div>
//         <button type='submit' disabled={loading} style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px" }}>
//           {
//             loading && <ClipLoader size={20} color='white' />
//           }
//           Send Message
//         </button>
//       </form>
//     </section>
//   )
// }

// export default Contact
